import { Component, Input, OnInit } from '@angular/core';
import { FormDomainScriptGuideLegacyPageAssistService } from '../page-assist-service/page-assist.service';
import { FormDomainScriptGuideService } from '../../../form-domain-script-guide.service';

@Component({
    selector: 'form-domain-script-guide-legacy-page-assist-settings',
    standalone: false,
    templateUrl: './settings.html',
})
export class FormDomainScriptGuideLegacyPageAssistSettingsComponent implements OnInit {
    @Input() prefixName?: string;
    @Input() pageAssistModel: any;

    settings: any;
    directions: any[] = [];
    themes: any[] = [];

    constructor (
        private formDomainScriptGuideLegacyPageAssistService: FormDomainScriptGuideLegacyPageAssistService,
        private formDomainScriptGuideService: FormDomainScriptGuideService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.prefixName = this.prefixName || '';
        this.settings = this.pageAssistModel.legacySettings;
        this.settings.theme = this.formDomainScriptGuideLegacyPageAssistService.getTheme(this.settings.theme);
        this.settings.direction = this.formDomainScriptGuideLegacyPageAssistService.getDirection(this.settings.direction);
        this.directions = this.formDomainScriptGuideLegacyPageAssistService.getDirections();
        this.themes = this.formDomainScriptGuideLegacyPageAssistService.getThemes();
    }

    updateDomainSettings () {
        setTimeout(() => {
            this.formDomainScriptGuideService.setPageAssistEdit(this.pageAssistModel);
        });
    }
}
